// extracted by mini-css-extract-plugin
export default {"id":"DetailModal_id__GapXF","section":"DetailModal_section__5EbQ+","details":"DetailModal_details__EH2Lt","description":"DetailModal_description__oxTa3"};